/**
 * billingType.js
 * Cobertura do agendamento: Particular ou Convênio (carteirinha da pessoa).
 * Valores iguais aos do banco (`company_appointments.billing_type`).
 * Especificação: docs/features/convenios/README.md
 */

export const BILLING_PRIVATE = 'private';
export const BILLING_INSURANCE = 'insurance';

export const BILLING_TYPE_OPTIONS = [
  { id: BILLING_PRIVATE, label: 'Particular' },
  { id: BILLING_INSURANCE, label: 'Convênio' },
];

export const INSURANCE_CARD_REQUIRED_ERROR = 'Escolha ou cadastre a carteirinha';

/** Cobertura válida a partir de qualquer valor (ausente = particular) */
export function normalizeBillingType(value) {
  return value === BILLING_INSURANCE ? BILLING_INSURANCE : BILLING_PRIVATE;
}

export function isInsuranceAppointment(appointment) {
  return appointment?.billing_type === BILLING_INSURANCE;
}

export function billingTypeLabel(type) {
  return type === BILLING_INSURANCE ? 'Convênio' : 'Particular';
}

/**
 * Rótulo curto de uma carteirinha: "Unimed · Celeste · 0123 4567".
 * Aceita o objeto devolvido por patients/insurance/list.php.
 */
export function insuranceCardLabel(card, { withNumber = true } = {}) {
  if (!card) return '';
  const parts = [card.provider_name || card.providerName];
  const plan = card.plan_name || card.planName;
  if (plan) parts.push(plan);
  if (withNumber && card.card_number) parts.push(card.card_number);
  return parts.filter(Boolean).join(' · ');
}

/** Rótulo da cobertura do agendamento, pronto para card, painel e tela do atendimento */
export function coverageLabel(appointment) {
  if (!isInsuranceAppointment(appointment)) return 'Particular';
  return appointment.insurance_label ? `Convênio · ${appointment.insurance_label}` : 'Convênio';
}

/** Situações manuais da guia/autorização (Fase 2). "Autorizada" é informada pela recepção. */
export const AUTHORIZATION_STATUS_OPTIONS = [
  { id: 'pending', label: 'Aguardando autorização' },
  { id: 'authorized', label: 'Autorizada (informada pela recepção)' },
  { id: 'denied', label: 'Negada' },
  { id: 'cancelled', label: 'Cancelada' },
];

export function authorizationStatusLabel(status) {
  const found = AUTHORIZATION_STATUS_OPTIONS.find((o) => o.id === status);
  return found ? found.label : 'Aguardando autorização';
}

export const AUTHORIZATION_TYPE_OPTIONS = [
  { id: 'consultation', label: 'Consulta' },
  { id: 'sp_sadt', label: 'SP/SADT (exames e procedimentos)' },
  { id: 'hospitalization', label: 'Internação' },
  { id: 'other', label: 'Outro' },
];

export function authorizationTypeLabel(type) {
  const found = AUTHORIZATION_TYPE_OPTIONS.find((o) => o.id === type);
  return found ? found.label : 'Consulta';
}
